export * from './Compartment/Compartment.actions';

export const FETCH_BOXES = '@@box/FETCH_BOXES';
export const FETCH_BOXES_SUCCESS = '@@box/FETCH_BOXES_SUCCESS';
export const FETCH_BOXES_ERROR = '@@box/FETCH_BOXES_ERROR';
export const CANCEL_FETCH_BOXES = '@@box/CANCEL_FETCH_BOXES';
export const RESET_BOXES = '@@box/RESET_BOXES';

export const FETCH_BOX_BY_ID = '@@box/FETCH_BOX_BY_ID';
export const FETCH_BOX_BY_ID_SUCCESS = '@@box/FETCH_BOX_BY_ID_SUCCESS';
export const FETCH_BOX_BY_ID_ERROR = '@@box/FETCH_BOX_BY_ID_ERROR';
export const CANCEL_FETCH_BOX_BY_ID = '@@box/CANCEL_FETCH_BOX_BY_ID';

export const SAVE_BOX_BY_ID = '@@box/SAVE_BOX_BY_ID';
export const SAVE_BOX_BY_ID_SUCCESS = '@@box/SAVE_BOX_BY_ID_SUCCESS';
export const SAVE_BOX_BY_ID_ERROR = '@@box/SAVE_BOX_BY_ID_ERROR';
export const CANCEL_SAVE_BOX_BY_ID = '@@box/CANCEL_SAVE_BOX_BY_ID';

export const REMOVE_BOX_BY_ID = '@@box/REMOVE_BOX_BY_ID';
export const REMOVE_BOX_BY_ID_SUCCESS = '@@box/REMOVE_BOX_BY_ID_SUCCESS';
export const REMOVE_BOX_BY_ID_ERROR = '@@box/REMOVE_BOX_BY_ID_ERROR';
export const CANCEL_REMOVE_BOX_BY_ID = '@@box/CANCEL_REMOVE_BOX_BY_ID';

export const TABLE_SELECT_BOX = '@@box/TABLE_SELECT_BOX';

export const selectBoxTable = id => ({
  type: TABLE_SELECT_BOX,
  id
});

export const fetchBoxes = config => ({
  type: FETCH_BOXES,
  ...config
});

export const fetchBoxesSuccess = resp => ({
  type: FETCH_BOXES_SUCCESS,
  payload: resp
});

export const fetchBoxesError = err => ({
  type: FETCH_BOXES_ERROR,
  payload: err
});

export const fetchBoxById = config => ({
  type: FETCH_BOX_BY_ID,
  ...config
});

export const fetchBoxByIdSuccess = resp => ({
  type: FETCH_BOX_BY_ID_SUCCESS,
  payload: resp
});

export const fetchBoxByIdError = err => ({
  type: FETCH_BOX_BY_ID_ERROR,
  payload: err
});

export const saveBoxById = (payload) => ({
  type: SAVE_BOX_BY_ID,
  payload
});

export const saveBoxByIdSuccess = (payload, id) => ({
  type: SAVE_BOX_BY_ID_SUCCESS,
  payload,
  id
});

export const saveBoxByIdError = err => ({
  type: SAVE_BOX_BY_ID_ERROR,
  payload: err
});

export const resetBoxes = () => ({
  type: RESET_BOXES
});

export const removeBoxById = payload => ({
  type: REMOVE_BOX_BY_ID,
  ...payload
});

export const removeBoxByIdSuccess = payload => ({
  type: REMOVE_BOX_BY_ID_SUCCESS,
  ...payload
});

export const removeBoxByIdError = err => ({
  type: REMOVE_BOX_BY_ID_ERROR,
  payload: err
});
